export default __webpack_public_path__ + "static/media/BOWire2.24fb073e.png";